import { Button, ButtonProps } from "@chakra-ui/react";

interface TaskActionButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export default function TaskActionButton({ children, ...rest }: TaskActionButtonProps) {
  return (
    <Button
      h="22px"
      fontSize="12px"
      color="whiteAlpha.900"
      bg="cdsIndigo.400"
      _hover={{
        bg: "cdsIndigo.100",
        color: "cdsIndigo.400",
      }}
      px="2"
      {...rest}
    >
      {children}
    </Button>
  );
}
